import { createRoute } from "@tanstack/react-router";
import { requirePermissions } from "@/app/guards";
import { PAYMENTS_PERMISSIONS } from "@/app/nav";
import { PAYMENT_STATUSES, PaymentsWorkspace, type PaymentStatusFilter } from "@/features/payments/PaymentsWorkspace";
import { type PageSearch, pageSearch } from "@/routes/paging";
import { staffRoute } from "@/routes/staff";

type PaymentsSearch = {
  status?: PaymentStatusFilter;
  batch?: string;
  purpose?: "induction" | "reissue";
} & PageSearch;

const isStatus = (value: unknown): value is PaymentStatusFilter =>
  PAYMENT_STATUSES.includes(value as PaymentStatusFilter);

export const paymentsRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "payments",
  // Set, never omit, each key: the router merges this over the raw query string.
  validateSearch: (search: Record<string, unknown>): PaymentsSearch => ({
    status: isStatus(search.status) ? search.status : undefined,
    purpose: search.purpose === "induction" || search.purpose === "reissue" ? search.purpose : undefined,
    batch: typeof search.batch === "string" && search.batch.trim() !== "" ? search.batch.trim() : undefined,
    ...pageSearch(search),
  }),
  beforeLoad: ({ context }) => requirePermissions(context.session, PAYMENTS_PERMISSIONS),
  component: PaymentsWorkspace,
});
